<div class="section over-hide">
    <div class="section padding-top-120 padding-top-mob-nav section-background-rana rana-shell-flush">
        <div class="section-1400 rana-full-bleed">
            <div class="container-fluid px-0">

                <div class="row no-gutters rana-shell" id="educationAccordion">

                    <!-- LEFT FIXED MENU -->
                    <div class="col-lg-4 rana-shell-rail">
                        <div class="section border-4 p-3 p-xl-4 z-bigger rana-nav-rail">
                            <div class="row">
                                <div class="col-12 rana-nav-brand">
                                    <div class="rana-nav-brand-mark"><i class="uil uil-graduation-hat"></i></div>
                                    <div>
                                        <div class="rana-nav-brand-title">RANA</div>
                                        <div class="rana-nav-brand-subtitle">Education Trust Fund</div>
                                    </div>
                                </div>

                                <div class="col-12 d-lg-none">
                                    <button type="button" class="rana-nav-mobile-toggle" data-toggle="collapse"
                                            data-target="#educationNavRailLinks" aria-expanded="false"
                                            aria-controls="educationNavRailLinks">
                                        <span>Menu</span>
                                        <i class="uil uil-angle-down size-20"></i>
                                    </button>
                                </div>
                                <div class="col-12 collapse d-lg-block" id="educationNavRailLinks">
                                    <div class="rana-nav-group-label">Programs</div>
                                    <a href="javascript:void(0)"
                                       class="btn btn-user-profile btn-fluid justify-content-start px-3"
                                       data-toggle="collapse"
                                       data-target="#collapseOne"
                                       aria-expanded="true"
                                       aria-controls="collapseOne">
                                        <i class="uil uil-award size-22 mr-2 pr-1"></i> Scholarship Awards
                                    </a>

                                    <a href="javascript:void(0)"
                                       class="btn btn-user-profile btn-fluid justify-content-start mt-1 px-3"
                                       data-toggle="collapse"
                                       data-target="#collapseTwo"
                                       aria-expanded="false"
                                       aria-controls="collapseTwo">
                                        <i class="uil uil-university size-22 mr-2 pr-1"></i> Education Fund
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- RIGHT CONTENT AREA -->
                    <div class="col-lg-8 mt-4 mt-lg-0 rana-shell-main">
                        <div class="section border-4 p-3 p-xl-4 rana-shell-main-inner">

                            <!-- COLLAPSE ONE -->
                            <div id="collapseOne" class="collapse show p-0" data-parent="#educationAccordion">
                                <div class="card-body p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <h1 class="rana-page-title">Scholarship Awards</h1>
                                            <p class="rana-page-subtitle mb-3">2026–2027 session</p>
                                        </div>

                                        <div class="col-12">

                                            <p class="mb-3 font-weight-500">Dear RANA Members,</p>

                                            <p class="mb-1">
                                                As you know RANA education trust fund (ETF) is our charity fund. Every
                                                year we give out
                                                scholarships to needy & deserving Rajput students in India.
                                            </p>

                                            <p class="mb-4">
                                                Year 2026 to 2027 , RANA National Executive committee (NEC) has decided
                                                & awarded scholarships
                                                to 33 college students in India. Awards are based on multiple criteria,
                                                such as,
                                                amount of tuition, sponsor recommendation, family finance situations,
                                                research, analysis and
                                                verification...
                                            </p>

                                            <div class="rana-panel mb-4">
                                                <div class="rana-panel-title">Donate to the Education Trust Fund</div>
                                                <p class="text-muted mb-3">
                                                    This is only possible with your help. RANA ETF is charted under
                                                    IRC section 501(C)(3); donations are tax deductible.
                                                </p>

                                                <div class="rana-info-row mb-3">
                                                    <div class="rana-info-card">
                                                        <div class="rana-info-icon"><i class="uil uil-map-marker"></i></div>
                                                        <div class="min-width-0">
                                                            <div class="rana-info-label">Mail Checks To</div>
                                                            <div class="rana-info-value" style="font-size:14px;">
                                                                RANA Education Trust Fund<br>
                                                                Attn: Dilipsinh Rathod<br>
                                                                16 Joseph Dr, Sewell, NJ 08080
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div class="rana-info-card">
                                                        <div class="rana-info-icon success"><i class="uil uil-envelope"></i></div>
                                                        <div class="min-width-0">
                                                            <div class="rana-info-label">Questions</div>
                                                            <div class="rana-info-value" style="font-size:14px;">
                                                                856-889-4531<br>
                                                                education&#64;rajputra.org
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <a class="btn btn-dark-primary" target="_blank"
                                                   href="https://www.paypal.com/donate/?hosted_button_id=6N6UNJ6HD5LNA">
                                                    <i class="uil uil-paypal mr-1"></i> Donate via PayPal
                                                </a>
                                            </div>

                                            <p class="mb-1">With best regards to you and your family</p>

                                            <p class="mb-0 mt-4">Sincerely,</p>
                                            <p class="mb-0 font-weight-500">NEC Education secretary & Committee</p>

                                        </div>
                                    </div>
                                </div>
                            </div>

                            <!-- COLLAPSE TWO -->
                            <div id="collapseTwo" class="collapse p-0" data-parent="#educationAccordion">
                                <div class="card-body p-0">
                                    <div class="row">
                                        <div class="col-12">
                                            <h1 class="rana-page-title">RANA Education Trust Fund</h1>
                                            <p class="rana-page-subtitle mb-3">Charted under IRC Section 501(c)(3) — donations are tax-deductible.</p>
                                        </div>

                                        <div class="col-12">

                                            <div class="rana-info-row">
                                                <div class="rana-info-card">
                                                    <div class="rana-info-icon"><i class="uil uil-map-marker"></i></div>
                                                    <div class="min-width-0">
                                                        <div class="rana-info-label">RANA Education Trust Fund</div>
                                                        <div class="rana-info-value" style="font-size:14px;">16 Joseph Dr, Sewell, NJ 08080</div>
                                                    </div>
                                                </div>
                                            </div>

                                            <div class="rana-program-row">

                                                <div class="rana-program-card">
                                                    <div class="rana-info-icon success mb-3"><i class="uil uil-award"></i></div>
                                                    <h2 class="rana-panel-title">RANA Scholarships in India</h2>
                                                    <p class="text-muted">
                                                        Scholarships up to Rs. 15,000 annually. Deadline: August 15.
                                                    </p>
                                                    <a class="rana-action-btn" target="_blank"
                                                       href="../../assets/pdf/RANA_Scholarship_Application_Form_2024-25_INDIA.pdf">
                                                        <i class="uil uil-file-download-alt"></i> Download Education Form
                                                    </a>
                                                </div>

                                                <div class="rana-program-card">
                                                    <div class="rana-info-icon info mb-3"><i class="uil uil-graduation-hat"></i></div>
                                                    <h2 class="rana-panel-title">Scholarships for Members' Children in US & Canada</h2>
                                                    <p class="text-muted">
                                                        $1000 scholarships. Deadline: Nov 30th.
                                                    </p>
                                                    <a class="rana-action-btn" target="_blank"
                                                       href="../../assets/pdf/Rana-Scholarship-Application-Form-2023-24-USA_CANADA.pdf">
                                                        <i class="uil uil-file-download-alt"></i> Download Education Form
                                                    </a>
                                                </div>

                                                <div class="rana-program-card">
                                                    <div class="rana-info-icon mb-3"><i class="uil uil-university"></i></div>
                                                    <h2 class="rana-panel-title">Scholarships Awarded in India (2021–2023)</h2>
                                                    <p class="text-muted">
                                                        25 academic scholarships were issued in 2022–2023.
                                                    </p>
                                                    <a class="rana-action-btn" target="_blank"
                                                       href="../../assets/pdf/RANA-Scholarship-List-2022-2023-2022-10_12.pdf">
                                                        <i class="uil uil-file-download-alt"></i> Download Education Form
                                                    </a>
                                                </div>

                                            </div>

                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>

            </div>
        </div>
    </div>
</div>
